import { __extends } from "tslib";
import { AmbientBasicMethod, _Shader_AmbientBasicMethod } from './AmbientBasicMethod';
/**
 * AmbientDepthMethod provides a debug method to visualise depth maps
 */
var AmbientDepthMethod = /** @class */ (function (_super) {
    __extends(AmbientDepthMethod, _super);
    /**
     * Creates a new AmbientDepthMethod object.
     */
    function AmbientDepthMethod(castingLight) {
        var _this = _super.call(this) || this;
        _this._castingLight = castingLight;
        castingLight.shadowsEnabled = true;
        _this._shadowMapper = castingLight.shadowMapper;
        _this.iAddTexture(castingLight.shadowMapper.textureMap);
        return _this;
    }
    Object.defineProperty(AmbientDepthMethod.prototype, "assetType", {
        /**
         * @inheritDoc
         */
        get: function () {
            return AmbientDepthMethod.assetType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AmbientDepthMethod.prototype, "castingLight", {
        /**
         * The light casting the shadows.
         */
        get: function () {
            return this._castingLight;
        },
        enumerable: false,
        configurable: true
    });
    AmbientDepthMethod.assetType = '[asset AmbientDepthMethod]';
    return AmbientDepthMethod;
}(AmbientBasicMethod));
export { AmbientDepthMethod };
import { ShaderBase } from '@awayjs/renderer';
/**
 * AmbientDepthChunk provides a debug method to visualise depth maps
 */
var _Shader_AmbientDepthMethod = /** @class */ (function (_super) {
    __extends(_Shader_AmbientDepthMethod, _super);
    /**
     * Creates a new AmbientBasicChunk object.
     */
    function _Shader_AmbientDepthMethod(method, shader) {
        var _this = _super.call(this, method, shader) || this;
        var texture = method.castingLight.shadowMapper.textureMap;
        _this._shadowTexture = texture.getAbstraction(_this._shader);
        return _this;
    }
    /**
     * @inheritDoc
     */
    _Shader_AmbientDepthMethod.prototype._initVO = function (chunkVO) {
        this._shadowTexture._initVO(chunkVO);
    };
    /**
     * @inheritDoc
     */
    _Shader_AmbientDepthMethod.prototype._initConstants = function () {
        this._shadowTexture._initConstants();
        var data = this._shader.fragmentConstantData;
        var index = this._decRegIndex;
        data[index] = 1.0;
        data[index + 1] = 1 / 255.0;
        data[index + 2] = 1 / 65025.0;
        data[index + 3] = 1 / 16581375.0;
    };
    _Shader_AmbientDepthMethod.prototype._getFragmentCode = function (targetReg, registerCache, sharedRegisters) {
        var code = '';
        var decReg;
        var decReg = registerCache.getFreeFragmentConstant();
        this._decRegIndex = decReg.index * 4;
        code += this._shadowTexture._getFragmentCode(targetReg, registerCache, sharedRegisters, sharedRegisters.uvVarying) +
            'dp4 ' + targetReg + '.x, ' + targetReg + ', ' + decReg + '\n' +
            'mov ' + targetReg + '.yz, ' + targetReg + '.xx			\n' +
            'mov ' + targetReg + '.w, ' + decReg + '.x\n' +
            'sub ' + targetReg + '.xyz, ' + decReg + '.xxx, ' + targetReg + '.xyz\n';
        return code;
    };
    return _Shader_AmbientDepthMethod;
}(_Shader_AmbientBasicMethod));
export { _Shader_AmbientDepthMethod };
ShaderBase.registerAbstraction(_Shader_AmbientDepthMethod, AmbientDepthMethod);
